import React, { useState, useEffect } from "react";
import PersonalAccountLayout from 'layouts/PersonalAccountLayout';
import PageSpace from "components/styles/pageSpace";
import PageTitleStyle from "components/styles/PageTitleStyle";
import HomepageLayout from 'layouts/HomepageLayout.js';
import config from "config";
    // reactstrap components
import {
  Button,
  Card,
  CardTitle,
  Input,
  Media,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";


import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

function PrivacyPolicyView() {
  const [numPages, setNumPages] = useState(null);
	const [pageNumber, setPageNumber] = useState(1);
  const onDocumentLoadSuccess = ({ numPages }) => {
		setNumPages(numPages);
	};
  const goToPrevPage = () =>
  setPageNumber(pageNumber - 1 <= 1 ? 1 : pageNumber - 1);

const goToNextPage = () =>
  setPageNumber(
    pageNumber + 1 >= numPages ? numPages : pageNumber + 1,
  );
  React.useEffect(() => {
    document.body.classList.add("blog-post");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("blog-post");
      document.body.classList.remove("sidebar-collapse");
    };
  });


  
  return (
    <>
      <HomepageLayout/>
      <PageSpace />
      <PageTitleStyle 
        title="Politique de confidentialité"
      />
      <PageSpace />
      <Container>

        <Row className="mt-1">
        <Col lg="2">
        </Col>
        <Col lg="8">
          <nav>
            <Button style={{ marginRight: '.5rem' }} onClick={goToPrevPage}>Précédent</Button>
            <Button style={{ marginLeft: '.5rem' }} onClick={goToNextPage}>Suivant</Button>
            <p>
              Page {pageNumber} of {numPages}
            </p>
          </nav>
          <Row className="mt-1">
            <Document file={`${config.Private_Policy_URL}`} onLoadSuccess={onDocumentLoadSuccess}>
              <Page pageNumber={pageNumber} />
            </Document>
        </Row>
        </Col>
        <Col lg="2">
        </Col>
        </Row>
      </Container>
    </>
  );
}

export default PrivacyPolicyView;
